import { MultipleQueriesQuery } from "@algolia/client-search";
import algoliasearch from "algoliasearch/lite";
import * as React from "react";
import { StateResultsProvided } from "react-instantsearch-core";
import {
  connectStateResults,
  InstantSearch,
  SearchBox,
} from "react-instantsearch-dom";
import { indexName } from "./index_name";
import { IndexProps } from "./index_props";
import { AdvisorIndex } from "./indices/advisor";
import { ArticleIndex } from "./indices/article";
import { BrandIndex } from "./indices/brand";
import { CategoryIndex } from "./indices/category";
import { DocumentIndex } from "./indices/document";
import { ProductIndex } from "./indices/product";
import "./styles/search_style.sass";

const algoliaClient = algoliasearch(
  "LYUGJ5K51U",
  "1f22f1be4fca34bf3d4560c8db611377"
);

const searchClient = {
  search(requests: MultipleQueriesQuery[]) {
    if (requests.every(({ params }) => !params?.query)) {
      return;
    }
    return algoliaClient.search(requests);
  },
};

const relocateToBackendSearch = (event: any) => {
  event.preventDefault();
  document.location.href = `/search?query=${
    event.target.querySelector(".ais-SearchBox-input").value
  }`;
};

type SearchProps = IndexProps;

type SearchResultsProps = IndexProps & StateResultsProvided;

export const Search = ({ environment }: SearchProps): JSX.Element | null => (
  <div>
    <InstantSearch
      indexName={indexName(environment, "Sporilek_Category")}
      searchClient={searchClient}
    >
      <SearchBox
        submit={<span>Hledat</span>}
        onSubmit={(event) => relocateToBackendSearch(event)}
        translations={{
          submitTitle: "Zadejte hledaný výraz.",
          resetTitle: "Vymazat hledaný výraz.",
          placeholder: "Hledaný výraz...",
        }}
      />
      <SearchResults environment={environment} />
    </InstantSearch>
  </div>
);

const SearchResults = connectStateResults<SearchResultsProps>(
  ({ searchState, environment }): JSX.Element | null => {
    if (!searchState.query) return null;

    return (
      <div className="search-results">
        <CategoryIndex environment={environment} />
        <ProductIndex environment={environment} />
        <BrandIndex environment={environment} />
        <ArticleIndex environment={environment} />
        <AdvisorIndex environment={environment} />
        <DocumentIndex environment={environment} />
      </div>
    );
  }
);
